// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3sr6g","inputWrap":"CustomTip_inputWrap__3RPSn"};